import React from "react";
import TenantSlaSection from "../../Sections/SLA";
import Dashboard from "../Dashboard/Dashboard";

const TenantSLAComponent = () => {
    return (
        <Dashboard sectionName={<TenantSlaSection />} />
    );
};

export default TenantSLAComponent;